import {fetchDelete, fetchPatch, generateEndpoint} from "../../../utils/request";

export const acceptCaseById = async({ token, acceptedCase }) => {
  const url = `${generateEndpoint('acceptCase')}`;
  return fetchPatch(url, token, { acceptedCase });
};

export const rejectCaseById = async({ token, rejectedCase }) => {
  const url = `${generateEndpoint('rejectCase')}`;
  return fetchPatch(url, token, { rejectedCase });
};

export const updateCaseStatus = async({ token, id, status }) => {
  const url = `${generateEndpoint('updateCaseStatus')}`;
  return fetchPatch(url, token, { id, status });
};

export const reportCase = async({ token, reportedCase, report }) => {
  const url = `${generateEndpoint('reportCase')}`;
  return fetchPatch(url, token, { reportedCase, report });
};

export const assignCase = async({ token, organizationId, assignedCase, category }) => {
  const url = `${generateEndpoint('assignCase')}`;
  return fetchPatch(url, token, { organizationId, assignedCase, category });
};

export const deleteCase = async({ token, id }) => {
  const url = `${generateEndpoint('deleteCase')}`;
  return fetchDelete(url, token, { id });
};
